module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker82-api.relevant-digital.com/"}};